export const orderLicenseLink = 'https://skole.aschehoug.no/produktkatalog/modus'
export const productCatalogVgsLanguagesLink = 'https://skole.aschehoug.no/produktkatalog?level=vgs&subject=languages'
